<div class="row back-btn-height">
  <div class="col" style="overflow: auto; max-height: 400px">
    @if (
      selectedEvent?.detail ||
      canEditEventUpdate ||
      canDeleteRestoreCommentPhoto ||
      selectedEvent?.file
    ) {
      <div class="border rounded py-2 px-3 mb-2 shadow">
        @if (scanDistanceInfo?.scanDistance) {
          <div class="text-danger my-2">
            Scanned outside configured checkpoint radius
          </div>
        }
        <dl>
          <!--additional information-->
          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <dt>
                <span class="fw-bold">
                  {{
                    selectedEvent?.event_action !== 6
                      ? selectedEvent?.action
                      : "Scanned QR Checkpoint"
                  }}
                </span>
                @if (editedDetails?.updated_at) {
                  <span>
                    | Edited [
                    {{
                      editedDetails?.updated_at | customDate: "d MMM y HH:mm"
                    }}
                    ]
                  </span>
                }
              </dt>
            </div>
            @if (canEditEventUpdate) {
              <div (click)="editUserComment.emit(selectedEvent)" class="mx-2">
                <span>
                  <i
                    class="fa-solid fa-pen-to-square md-font-size text-secondary"
                  ></i>
                </span>
              </div>
            }
            @if (canDeleteRestoreCommentPhoto) {
              <div
                (click)="
                  deleteRestoreUserUpdate.emit({
                    event: selectedEvent,
                    type: selectedEvent?.is_deleted ? 'restore' : 'delete',
                  })
                "
                class="ms-1"
              >
                @if (selectedEvent?.is_deleted) {
                  <span>
                    <i
                      class="fa-solid fa-trash-can-arrow-up md-font-size text-secondary"
                    ></i>
                  </span>
                } @else {
                  <span>
                    <i class="fs-5 fa-solid fa-circle-minus text-danger"></i>
                  </span>
                }
              </div>
            }
          </div>
          <dd class="gt-multi-line">
            <div
              [ngClass]="canEditEventUpdate ? 'link-edit' : ''"
              (click)="
                canEditEventUpdate ? editUserComment.emit(selectedEvent) : ''
              "
              class="mb-3"
            >
              @if (
                (selectedEventFrom == "job" &&
                  selectedEvent?.event_action == 14) ||
                (selectedEventFrom == "patrol" &&
                  selectedEvent?.event_action == 13)
              ) {
                @let parsedData = selectedEvent?.detail | misc: "jsonParse";
                @if (parsedData?.start) {
                  <div class="d-flex gap-1 align-items-center">
                    <div class="text-secondary">Start Time:</div>

                    {{
                      parsedData?.start?.previous | customDate: "d MMM y HH:mm"
                    }}
                    <div class="text-secondary">-></div>
                    {{
                      parsedData?.start?.updated | customDate: "d MMM y HH:mm"
                    }}
                  </div>
                }

                @if (parsedData?.end) {
                  <div class="d-flex gap-1 align-items-center">
                    <div class="text-secondary">End Time:</div>

                    {{
                      parsedData?.end?.previous | customDate: "d MMM y HH:mm"
                    }}
                    <div class="text-secondary">-></div>

                    {{ parsedData?.end?.updated | customDate: "d MMM y HH:mm" }}
                  </div>
                }
              } @else {
                {{ selectedEvent?.detail }}
              }
            </div>
            @if (selectedEvent?.eta) {
              <span
                >[ETA:
                {{ selectedEvent?.eta | customDate: "d MMM y HH:mm" }} ]</span
              >
            }
            @if (
              selectedEvent?.user_provided_timestamp &&
              (selectedEvent?.user_provided_timestamp
                | customDate
                  : "d MMM y
          HH:mm") != (selectedEvent?.updated_at | customDate: "d MMM y HH:mm")
            ) {
              <span>
                [{{
                  selectedEvent?.user_provided_timestamp
                    | customDate: "d MMM y HH:mm"
                }}]
              </span>
            }
            @if (
              selectedEvent?.event_action === 1 &&
              selectedEvent?.status_identity === 12 &&
              selectedEventFrom === "job" &&
              selectedEvent?.event_add_info?.event_value
            ) {
              <div>
                Reason: {{ selectedEvent?.event_add_info?.event_value }}
              </div>
            }
            @if (selectedEvent?.file) {
              <div (click)="onOpenFile(selectedEvent)">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    selectedEvent?.file_extension
                  )
                ) {
                  <video
                    controls
                    style="
                      max-height: 100%;
                      max-width: 100%;
                      display: flex;
                      width: 100%;
                    "
                  >
                    <source src="{{ selectedEvent?.file }}" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    class="cursor-pointer mw-100 border border-secondary"
                    src="{{ selectedEvent?.file }}"
                    alt="Guard Tracker"
                  />
                }
              </div>
            }
          </dd>
          <div class="small-font text-secondary text-end pt-2">
            @if (deletedDetails?.updated_at) {
              <div>
                Deleted:
                {{ deletedDetails?.updated_at | customDate: "d MMM y HH:mm" }} |
                {{ deletedDetails?.user_name }}
              </div>
            }
            @if (restoredDetails?.updated_at && !selectedEvent?.is_deleted) {
              Restored:
              {{ restoredDetails?.updated_at | customDate: "d MMM y HH:mm" }} |
              {{ restoredDetails?.user_name }}
            }
          </div>
        </dl>
      </div>
    }

    <div class="p-3">
      <div class="d-flex flex-wrap column-gap-5 row-gap-3 mb-3">
        @for (indColumn of userEventDetailsTableView; track indColumn) {
          @if (
            indColumn.nestedValue
              ? indColumn.nestedValue(selectedEvent)
              : selectedEvent[indColumn.name]
          ) {
            <div>
              <dt class="text-uppercase">
                {{ indColumn?.header }}
              </dt>
              <!--style whole row either based on condition or common to all -->
              @if (indColumn?.datetimeObj == true) {
                <div>
                  <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalPrefixStyle
                        ? indColumn?.conditionalPrefixStyle(this.selectedEvent)
                        : indColumn?.prefixStyle
                    "
                  >
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    {{
                      indColumn?.prefixNestedValue
                        ? indColumn?.prefixNestedValue(this.selectedEvent)
                        : indColumn?.prefix
                          ? indColumn?.prefix
                          : ""
                    }}
                  </span>
                  <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  <!-- main content which will be passed from the backend STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalColumnDataStyle
                        ? indColumn?.conditionalColumnDataStyle(
                            this.selectedEvent
                          )
                        : indColumn?.columnDataStyle
                    "
                  >
                    {{
                      indColumn.nestedValue
                        ? (indColumn.nestedValue(this.selectedEvent)
                          | customDate
                            : (indColumn.dateTimeFormat
                                ? indColumn.dateTimeFormat
                                : "d MMM y HH:mm"))
                        : (this.selectedEvent[indColumn.name]
                          | customDate
                            : (indColumn.dateTimeFormat
                                ? indColumn.dateTimeFormat
                                : "d MMM y HH:mm"))
                    }}
                  </span>
                  <!-- main content which will be passed from the backend ENDS-->
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalSuffixStyle
                        ? indColumn?.conditionalSuffixStyle(this.selectedEvent)
                        : indColumn?.suffixStyle
                    "
                  >
                    {{
                      indColumn?.suffixNestedValue
                        ? indColumn?.suffixNestedValue(this.selectedEvent)
                        : indColumn?.suffix
                          ? indColumn?.suffix
                          : ""
                    }}
                  </span>
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                </div>
              }
              <!-- rows where objects are datetime objects ENDS-->
              <!-- rows where objects are normal objects STARTS-->
              <!--style whole row either based on condition or common to all -->
              @if (indColumn?.datetimeObj !== true) {
                <div>
                  <!--a row is typically divided into 3 prefix, main content and suffix, style each of them based on conditions or common -->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalPrefixStyle
                        ? indColumn?.conditionalPrefixStyle(this.selectedEvent)
                        : indColumn?.prefixStyle
                    "
                  >
                    <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                    {{
                      indColumn?.prefixNestedValue
                        ? indColumn?.prefixNestedValue(this.selectedEvent)
                        : indColumn?.prefix
                          ? indColumn?.prefix
                          : ""
                    }}
                  </span>
                  <!-- prefix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                  <!-- main content which will be passed from the backend STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalColumnDataStyle
                        ? indColumn?.conditionalColumnDataStyle(
                            this.selectedEvent
                          )
                        : indColumn?.columnDataStyle
                    "
                  >
                    {{
                      indColumn.nestedValue
                        ? indColumn.nestedValue(this.selectedEvent)
                        : this.selectedEvent[indColumn.name] == "null" ||
                            this.selectedEvent[indColumn.name] == "undefined"
                          ? "N/A"
                          : this.selectedEvent[indColumn.name]
                    }}
                  </span>
                  <!-- main content which will be passed from the backend ENDS-->
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) STARTS-->
                  <span
                    [ngStyle]="
                      indColumn?.conditionalSuffixStyle
                        ? indColumn?.conditionalSuffixStyle(this.selectedEvent)
                        : indColumn?.suffixStyle
                    "
                  >
                    {{
                      indColumn?.suffixNestedValue
                        ? indColumn?.suffixNestedValue(this.selectedEvent)
                        : indColumn?.suffix
                          ? indColumn?.suffix
                          : ""
                    }}
                  </span>
                  <!-- suffix (either hardcoded from ui or pased from backend via key-value pair) ENDS-->
                </div>
              }
            </div>
          }
        }
        @if (selectedEvent?.checkpoint_details?.min_distance) {
          <div>
            <dt class="text-uppercase">Geofence Radius (metres)</dt>
            <dd>
              {{
                selectedEvent?.checkpoint_details?.min_distance
                  | number: "1.0-0"
              }}
            </dd>
          </div>
        }
      </div>

      <div class="">
        @if (selectedEvent | misc: "serverReceivedDateTimeCheck") {
          <div class="mb-2">
            <dt class="text-danger fw-bold d-flex align-items-center">
              RECEIVED AT
              <span
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                class="ms-2"
                title="The time this event was uploaded."
              >
                <i class="fa-solid fa-circle-info"></i>
              </span>
            </dt>
            <dd>
              {{
                selectedEvent
                  | misc: "serverReceivedDateTimeCheck"
                  | date: "d MMM y HH:mm"
              }}
            </dd>
          </div>
        }
        @if (selectedEvent?.prompts?.length) {
          <gtapp-mobile-form-input-data
            [mobileFormDataInput]="selectedEvent?.prompts"
          >
          </gtapp-mobile-form-input-data>
        }
        @if (selectedEvent?.device_details && (isAdmin || isDispatchUser)) {
          <div class="d-flex flex-wrap column-gap-5 row-gap-3">
            @for (
              item of selectedEvent?.device_details | keyvalue;
              track item
            ) {
              <div>
                @if (item?.value) {
                  <div>
                    <dt class="text-uppercase">
                      {{ item.key }}
                    </dt>
                    <dd class="text-break">{{ item.value }}</dd>
                  </div>
                }
              </div>
            }
            @if (
              browserGpsInfo?.[selectedEvent?.gps?.source]?.description &&
              selectedEvent?.gps?.lat &&
              selectedEvent?.gps?.lon
            ) {
              <div>
                <dt>GPS Accuracy</dt>
                <dd>
                  {{
                    browserGpsInfo?.[selectedEvent?.gps?.source]?.description
                  }}
                </dd>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @if (isAdmin || isDispatchUser) {
    <div class="col-5">
      @if (selectedEvent?.gps?.lat) {
        <gtapp-map-leaflet
          [latLon]="selectedEvent?.gps"
          [scannedCheckpointDetails]="selectedEvent?.checkpoint_details"
          [mapId]="'event-location'"
        ></gtapp-map-leaflet>
      }
    </div>
  }
</div>
